

















import { Component, Model, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwButton } from '../sw-button';
// v-model submit conflict

const i18nPathPrefix = 'libShared.SwFileUpload';

@Component({
  components: {
    SwButton,
  },
})
export default class SwFileUpload extends SwExtendedVue {
  @Model('input', { required: true })
  value: File[];

  @Prop({ type: Boolean, required: false, default: false })
  disabled: boolean;

  @Prop({ type: Boolean, required: false, default: true })
  submittable: boolean;

  files:File[] = this.value;
  i18nPathPrefix = i18nPathPrefix;
  allowFileUploadComponent = false;

  addFiles() {
    if (!this.submittable) {
      this.allowFileUploadComponent = true;
    }
    setTimeout(() => {
      (this.$refs.files as HTMLElement).click();
    },         0);
  }

  @Watch('value')
  updateFiles() {
    this.files = this.value;
  }

  handleFilesUpload() {
    const uploadedFiles = (this.$refs.files as HTMLInputElement).files;
    (this.$refs.files as HTMLInputElement).type = 'text';
    (this.$refs.files as HTMLInputElement).type = 'file';

    if (uploadedFiles !== null) {
      for (let i = 0; i < uploadedFiles.length; i += 1) {
        if (uploadedFiles[i]) {
          this.files.push(uploadedFiles[i]);
        }
      }
    }
    if (!this.submittable) {
      this.allowFileUploadComponent = false;
    }
    this.$emit('input', this.files);
  }
}
